<script lang="ts">
	import type { Snippet } from "svelte";
	import ImageIcon from "@lucide/svelte/icons/image";

	interface Props {
		href: string;
		imageUrl?: string | null;
		imageAlt: string;
		badge?: Snippet;
		details: Snippet;
		class?: string;
	}

	let { href, imageUrl, imageAlt, badge, details, class: className }: Props = $props();

	let imageError = $state(false);

	function handleImageError() {
		imageError = true;
	}
</script>

<a
	{href}
	class="hover:no-underline {className ?? ''}"
	data-sveltekit-preload-data="tap"
	data-sveltekit-preload-code="hover"
>
	<div
		class="bg-card text-card-foreground group flex h-full flex-col overflow-hidden rounded shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
	>
		<div class="relative h-40 w-full shrink-0 overflow-hidden">
			{#if imageUrl && !imageError}
				<img
					src={imageUrl}
					alt={imageAlt}
					class="h-full w-full object-cover object-center transition-transform duration-300 group-hover:scale-105"
					loading="lazy"
					decoding="async"
					width="400"
					height="300"
					onerror={handleImageError}
				/>
				<div class="absolute inset-0 bg-linear-to-t from-black/50 to-transparent"></div>
			{:else}
				<div class="bg-muted flex h-full w-full items-center justify-center">
					<div class="flex flex-col items-center text-center">
						<ImageIcon class="text-muted-foreground mb-2 h-8 w-8" />
						<span class="text-muted-foreground text-sm font-medium">
							{imageError ? "Image unavailable" : "No photo available"}
						</span>
					</div>
				</div>
			{/if}
			{#if badge}
				<div class="absolute bottom-0 left-0 p-3">
					{@render badge()}
				</div>
			{/if}
		</div>
		<div class="p-3">
			{@render details()}
		</div>
	</div>
</a>
